import { render, staticRenderFns } from "./PurchasingClosePeriod.vue?vue&type=template&id=50f096a4&"
import script from "./PurchasingClosePeriod.vue?vue&type=script&lang=ts&"
export * from "./PurchasingClosePeriod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50f096a4')) {
      api.createRecord('50f096a4', component.options)
    } else {
      api.reload('50f096a4', component.options)
    }
    module.hot.accept("./PurchasingClosePeriod.vue?vue&type=template&id=50f096a4&", function () {
      api.rerender('50f096a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchasing/PurchasingClosePeriod.vue"
export default component.exports